/*
 * @Author: Smart Chow
 * @Date: 2022-01-05 21:32:10
 * @LastEditors: Smart Chow
 * @LastEditTime: 2022-01-05 22:33:10
 * @FilePath: /nqc-ui/src/frameworks/events/eventBus.js
 * @description
 * 全局事件广播与监听
 *
 * 导入eventBus
 * import eventBus from '@/frameworks/events/eventBus
 * 发送事件.
 * eventBus.$emit('YOUR_EVENT_NAME', yourData)
 * 监听事件
 * eventHub.$on('YOUR_EVENT_NAME', (yourData)=>{
 * handle(yourData)
 */
import Vue from 'vue'

const eventHub = new Vue()

export default eventHub
